import {RenderingServices, utils} from '@wallaby-ui/core';

import {EncounterTimelineEventAnnotation} from 'src/js/model/encounter_timeline';

export interface BaseEventAnnotationTypeParams {
  annotation: EncounterTimelineEventAnnotation;
}

export interface BaseEventAnnotationTypeParamsReturnType
  extends BaseEventAnnotationTypeParams {
  annotationLabel: string | undefined;
}

export function baseEventAnnotationTypeParams(
  params: BaseEventAnnotationTypeParams,
  services: RenderingServices = {}
): BaseEventAnnotationTypeParamsReturnType {
  const {intl} = services;
  const {annotation} = params;
  const annotationLabel =
    intl &&
    utils.TranslateUtils.translate(annotation.getDocumentType() ?? '', intl);

  return {...params, annotationLabel};
}
